import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {formatText} from 'common/util/format-text';
import {activateZendeskHelp} from 'common/report/external-widgets/zendesk';

import template from './index.jade';
import css from './index.styl?inline';

export interface OnboardingBannerAttrs {
  'header-text'?: string;
  'body-text'?: string;
  'image-url'?: string;
}

export class OnboardingBanner extends Component<EmptyObj, OnboardingBannerAttrs> {
  static get attrsSchema(): AttrsSchema<OnboardingBannerAttrs> {
    return {
      ...super.attrsSchema,
      'body-text': `string`,
      'header-text': `string`,
      'image-url': `string`,
    };
  }

  get config() {
    return {
      useShadowDom: true,
      css,
      template,
      helpers: {
        formatText,
        activateZendeskHelp: () => {
          activateZendeskHelp({labels: [`onboarding`]});
          const globalActionBar = document.querySelector(`global-action-bar`);
          if (globalActionBar) {
            globalActionBar.setAttribute(`is-support-widget-present`, true);
          }
        },
        onClose: () => {
          this.dispatchEvent(new CustomEvent(`close`));
        },
      },
    };
  }
}

export const OnboardingBannerEl = defineAndMakeJsxFactory(`mp-onboarding-banner`, OnboardingBanner);
